import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e49dd72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "team-invite-page"
}
const _hoisted_2 = {
  key: 0,
  class: "container maxWidth-sm form-inline"
}
const _hoisted_3 = {
  class: "text-center text-wrap",
  style: {"margin-top":"40px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = {
  class: "row",
  style: {"margin-top":"20px"}
}
const _hoisted_7 = { class: "col-sm-12 text-center" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "col-sm-10 col-sm-offset-1 text-big"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You do not have permission to invite to this team", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"50px"} }, null, -1))

import { debug as d } from "debug";
import axios, { AxiosError } from "axios";
import { computed, onBeforeMount, ref } from "vue";
import { InviteControlApiModel, TeamSettingsApiModel } from "../../api-models";
import TeamInviteControl from "../../components/invite-control/team-invite-control.vue";
import { csContext } from "../../services/cs-context";
import LoadingPage from "../loading-page.vue";

export interface GroupInviteModel {
  groupName: string;
  invites: InviteControlApiModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'team-invite',
  props: {
    id: {}
  },
  setup(__props: any) {

const debug = d("cs.TeamInvite");

const props = __props;
const name = ref<string | null>(null);
const model = ref<InviteControlApiModel | null>(null);
const teamSettingsModel = ref<TeamSettingsApiModel | null>(null);
const isLoading = ref(false);

const canInvite = computed(() => !!teamSettingsModel.value?.userPermissions.canInviteToGroup);
const isLicenceHolder = computed(() => csContext.userProfile.hasLicence);
const continueButtonUrl = computed(() => `/home?view=TeamDashboard&team=${props.id}`);

async function loadInviteModel(): Promise<void> {
  return axios
    .get(`/team/invitemodel/${props.id}`)
    .then((resp) => {
      const inviteModel = resp.data as GroupInviteModel;
      name.value = inviteModel.groupName;
      const controlModel = inviteModel.invites;
      controlModel.sendUrl = `/invitecodes/sendgroupinvites/${props.id}`;
      controlModel.peoplePhrase = inviteModel.groupName;
      debug(inviteModel.groupName);
      model.value = controlModel;
    })
    .catch((e: AxiosError) => {
      console.error(e);
    });
}

function loadData(): void {
  const axiosPromises: Promise<void>[] = [];
  axiosPromises.push(loadInviteModel());
  axiosPromises.push(
    axios
      .get(`/api/teamsettings/${props.id}`)
      .then((resp) => {
        teamSettingsModel.value = resp.data as TeamSettingsApiModel;
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 403) {
          window.location.href = "/errorpages/NotAuthorised";
        } else if (e.response?.status === 404) {
          window.location.href = "/errorpages/NotFound";
        } else {
          window.location.href = "/errorpages/Error";
        }
      }),
  );

  Promise.all(axiosPromises).then(() => {
    isLoading.value = false;
  });
}

onBeforeMount(() => {
  isLoading.value = true;
  loadData();
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (model.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, [
                _createTextVNode(" Invite team members to "),
                _hoisted_4,
                _createTextVNode("'" + _toDisplayString(name.value) + "' ", 1)
              ]),
              _hoisted_5,
              (!isLicenceHolder.value || canInvite.value)
                ? (_openBlock(), _createBlock(TeamInviteControl, {
                    key: 0,
                    model: model.value,
                    onDeletedEvent: loadInviteModel
                  }, null, 8, ["model"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "btn btn-lg btn-default",
                    href: continueButtonUrl.value
                  }, " Continue ", 8, _hoisted_8)
                ])
              ]),
              (isLicenceHolder.value && !canInvite.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})